import React from 'react';

import AdminMessengerPage from '../../screens/AdminMessengerPage/AdminMessengerPage.component';

const AdminMessenger: React.FC = () => <AdminMessengerPage />;

export default AdminMessenger;
